import { create } from 'zustand';
import authFetch from '../utils/authFetch';

function qs(params) {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== null && v !== undefined && v !== '') usp.set(k, v);
  }
  const s = usp.toString();
  return s ? `?${s}` : '';
}

// Store do módulo de monitoramento (M6b) — os três GETs de metrics.routes.js
// (M6a), sem nenhuma escrita: cada tela só busca e mostra.
const useMetricsStore = create((set) => ({
  // Fluxo de UM cartão, por card_id — o painel pode abrir cartões diferentes
  // na mesma sessão sem perder o que já foi buscado (mesmo padrão de
  // cardPanelStore para comments/attachments).
  cardFlow: {},
  loadingCardFlow: {},
  cardFlowError: {},

  fetchCardFlow: async (cardId) => {
    if (!cardId) return;
    set((s) => ({
      loadingCardFlow: { ...s.loadingCardFlow, [cardId]: true },
      cardFlowError: { ...s.cardFlowError, [cardId]: null },
    }));
    try {
      const data = await authFetch(`/api/v1/cards/${cardId}/flow`);
      set((s) => ({ cardFlow: { ...s.cardFlow, [cardId]: data } }));
    } catch (err) {
      set((s) => ({ cardFlowError: { ...s.cardFlowError, [cardId]: { status: err.status, message: err.message } } }));
    } finally {
      set((s) => ({ loadingCardFlow: { ...s.loadingCardFlow, [cardId]: false } }));
    }
  },

  // Métricas de UM quadro, com janela — guardadas por board_id. Sem cache por
  // período: o modal não fica aberto tempo suficiente para isso valer a pena,
  // e trocar o período sempre busca de novo.
  boardMetrics: {},
  loadingBoardMetrics: false,
  boardMetricsError: null,

  fetchBoardMetrics: async (boardId, { from, to } = {}) => {
    if (!boardId) return;
    set({ loadingBoardMetrics: true, boardMetricsError: null });
    try {
      const data = await authFetch(`/api/v1/boards/${boardId}/metrics${qs({ from, to })}`);
      set((s) => ({ boardMetrics: { ...s.boardMetrics, [boardId]: data } }));
    } catch (err) {
      set({ boardMetricsError: { status: err.status, message: err.message } });
    } finally {
      set({ loadingBoardMetrics: false });
    }
  },

  // Métricas por pessoa — uma lista só (com ou sem filtro de pessoa). `meta`
  // traz o recorte que o backend aplicou de fato (accessible_boards,
  // self_only) — a tela usa isso para nunca legendar um número parcial como
  // se fosse total (mesmo raciocínio do comentário em metrics.routes.js).
  peopleMetrics: [],
  peopleMetricsMeta: null,
  loadingPeopleMetrics: false,
  peopleMetricsError: null,

  fetchPeopleMetrics: async ({ from, to, userId } = {}) => {
    set({ loadingPeopleMetrics: true, peopleMetricsError: null });
    try {
      const res = await authFetch(`/api/v1/metrics/people${qs({ from, to, user_id: userId })}`, { full: true });
      set({ peopleMetrics: res.data, peopleMetricsMeta: res.meta });
    } catch (err) {
      set({ peopleMetrics: [], peopleMetricsMeta: null, peopleMetricsError: { status: err.status, message: err.message } });
    } finally {
      set({ loadingPeopleMetrics: false });
    }
  },
}));

export default useMetricsStore;
